import * as React from "react";
import { connectSearchBox } from "react-instantsearch-dom";

class SearchBox extends React.Component<any, any> {
	timerId;

	state = {
		value: this.props.currentRefinement
	};

	onChangeDebounced = event => {
		const { refine, delay } = this.props;
		const value = event.currentTarget.value;

		clearTimeout(this.timerId);
		this.timerId = setTimeout(() => refine(value), delay);
		this.setState(() => ({ value }));
	}

	onReset = () => {
		this.props.refine("");
		this.setState({ value: "" });
	}

	onSubmit = _event => {
		// if (typeof this.props.onSubmit === "function") {
		// 	event.preventDefault();
		// 	this.props.onSubmit(this.state.value);
		// }
	}

	render() {
		const { value } = this.state;

		return (
			<div className="ais-SearchBox">
				<form id="navigation-search" action={this.props.action} method="get" role="search"
							className="ais-SearchBox-form w-full" onSubmit={this.onSubmit}>
					<div className="flex menuSearchBox relative">
						<input
							id="search-input"
							type="search"
							placeholder={this.props.placeholder || "Search..."}
							autoComplete="off"
							autoCapitalize="off"
							spellCheck="false"
							maxLength={512}
							autoCorrect="off"
							name="query"
							value={value}
							className="border border-solid border-gray-300 w-full pl-4 py-2 ais-SearchBox-input"
							style={{paddingRight: '36px', background: 'rgb(243, 244, 246)'}}
							onChange={this.onChangeDebounced}
							required={false}
						/>
						{value &&
							<button type="reset" onClick={this.onReset} title="Clear the search query" className="ais-SearchBox-reset absolute right-14">
								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
										 stroke="currentColor" className="w-6 h-6 ais-SearchBox-resetIcon">
									<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
								</svg>
							</button>
						}
						<button
							style={{padding: '8px', display: 'flex', alignItems: 'center', borderRadius: '0 3px 3px 0'}}
							className="bg-brand-accent bn pointer menuSearchButton"
							type="submit">
							<svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
									 style={{color: '#fff', width: '24px', height: '24px'}}>
								<path stroke-linecap="round" stroke-linejoin="round"
											d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"/>
							</svg>
						</button>
					</div>
				</form>
			</div>
		);
	}
}

const SearchBoxDebounced = connectSearchBox(SearchBox);

export default SearchBoxDebounced;
